import request from "./superagent";

const cartRequest = function(action, token, obj) {
    var dto = { action: action };

    for (var attrname in obj) {
        dto[attrname] = obj[attrname];
    }

    var req = request
        .post(window.location.href)
        .type("form")
        .send(dto)
        .set({
            "X-CSRF-Token": token
        })
        .set("Accept", "application/json, text/javascript");

        // console.log('req', req);

    return req;
};

const setShippingAddressSameAsBilling = (token, value) => {
    return cartRequest("commerce/cart/update-cart", token, {
        shippingAddressSameAsBilling: value
    });
};

const updateAddressCountry = (token, addressId, country) => {
    if (!addressId) throw new Error("addressId cannot be empty.");
    var dto = {
        "address[id]": addressId,
        "address[countryId]": country
    };

    return cartRequest("commerce/customer-addresses/save", token, dto);
};

const updateAddress = (
    token,
    addressId,
    address1,
    zipCode,
    city,
    countryId,
    firstName,
    lastName,
    phone
) => {
    if (!addressId) throw new Error("addressId cannot be empty.");
    var dto = {
        "address[id]": addressId,
        "address[firstName]": firstName,
        "address[lastName]": lastName,
        "address[address1]": address1,
        "address[zipCode]": zipCode,
        "address[city]": city,
        "address[countryId]": countryId
    };
    if (phone != undefined) dto["address[phone]"] = phone;

    return cartRequest("commerce/customer-addresses/save", token, dto);
};

const getCart = token => {
    return cartRequest("commerce/cart/get-cart", token, {});
};

const getCustomCart = token => {
    var req = request.get("/cart-json").set("Accept", "application/json, text/javascript");

    return req;
};

const updateCoupon = (token, code) => {
    return cartRequest("commerce/cart/update-cart", token, {
        couponCode: code
    });
};

const updateEmail = (token, email) => {
    return cartRequest("commerce/cart/update-cart", token, {
        email: email
    });
};

const updateCartNote = (token, note) => {
    return cartRequest("commerce/cart/update-cart", token, {
        'fields[cartNote]': note
    }); 
}

const addToCart = (token, purchasableId, quantity, extras) => {
    return cartRequest("van-eccelpoel-module/cart/add", token, {
        purchasableId: purchasableId,
        extras: JSON.stringify(extras),
        qty: quantity
    });
};

// const updateQuantity = (token, purchasableId, quantity) => {
//     return cartRequest("commerce/cart/update-cart", token, {
//         purchasableId: purchasableId,
//         qty: quantity
//     });
// };

const setQuantity = (token, lineItemId, quantity) => {
    return cartRequest("van-eccelpoel-module/cart/set-quantity", token, {
        lineItemId: lineItemId,
        qty: quantity
    });
};

const removeItem = (token, lineItemId) => {
    return cartRequest("van-eccelpoel-module/cart/remove", token, {
        lineItemId: lineItemId
    });
};

const processErrors = dto => {
    if (dto.error) {
        var err = dto.error;
        var errors = dto.cart.errors;
        
        console.error(err, errors);
    }
};

const updateShippingMethod = (token, shippingMethod) => {
    return cartRequest("commerce/cart/update-cart", token, {
        shippingMethodHandle: shippingMethod
    });
};

export {
    cartRequest,
    updateAddressCountry,
    getCart,
    updateShippingMethod,
    processErrors,
    addToCart,
    setQuantity,
    updateCoupon,
    updateCartNote,
    removeItem,
    getCustomCart,
    setShippingAddressSameAsBilling,
    updateAddress,
    updateEmail
};
